import { useEffect, useState } from "react";

export const useInterpretiveQuestions = (
  generatedQuestionsFromSubmitContent,
  totalQuestionNumber,
  isGPT
) => {
  // console.log(
  //   "generatedQuestionsFromSubmitContent in interpretiveQuestions:",
  //   generatedQuestionsFromSubmitContent
  // );
  const [interpretiveQuestions, setInterpretiveQuestions] = useState([]);

  const [interpretiveCount, setInterpretiveCount] = useState(0);

  
  useEffect (() =>{
    const interpretiveTotal = interpretiveQuestions.length;
    setInterpretiveCount(interpretiveTotal);
  },[interpretiveQuestions])

  const handleInterpretiveQuestionChange = (index, newValue, pIndex = 0) => {
    const updatedQuestions = [...interpretiveQuestions];
    if (isGPT) {
      if('question' in updatedQuestions[index]){
        updatedQuestions[index].question = newValue;
      }else if ('Question' in updatedQuestions[index]){
        updatedQuestions[index].Question = newValue; 
      }
    } else {
      if('question' in updatedQuestions[index]){
        updatedQuestions[index].question = newValue;
      }else if ('Question' in updatedQuestions[index]){
        updatedQuestions[index].Question = newValue; 
      }
    }
    setInterpretiveQuestions(updatedQuestions);
  };

  const handleInterpretiveAnswerChange = (index, newValue, pIndex = 0) => {
    const updatedQuestions = [...interpretiveQuestions];
    if (isGPT){ 
      if ('answer' in updatedQuestions[index]){
        updatedQuestions[index].answer = newValue;
      }else if ('Answer' in updatedQuestions[index]){
        updatedQuestions[index].Answer = newValue;
      }
    }else {
      if ('answer' in updatedQuestions[index]){
        updatedQuestions[index].answer = newValue;
      }else if ('Answer' in updatedQuestions[index]){
        updatedQuestions[index].Answer = newValue;
      }
    }
    setInterpretiveQuestions(updatedQuestions);
  };

  const handleInterpretiveQuestionsEdit = (index, pIndex = 0) => {
    const updatedQuestions = [...interpretiveQuestions];
    if (isGPT) {
      updatedQuestions[index].editing = !updatedQuestions[index].editing;

      if (updatedQuestions[index].editing) {
        // After setting editing to true, focus on the contentEditable div for the question
        setTimeout(() => {
          const contentEditableElement = document.getElementById(
            `question-${index}`
          ); // Add an ID to your contentEditable element
          if (contentEditableElement) {
            contentEditableElement.focus();
          }
        }, 0);
      }
    } else {
      updatedQuestions[index].editing = !updatedQuestions[index].editing;

      if (updatedQuestions[index].editing) {
        // After setting editing to true, focus on the contentEditable div for the question
        setTimeout(() => {
          const contentEditableElement = document.getElementById(
            `question-${index}`
          ); // Add an ID to your contentEditable element
          if (contentEditableElement) {
            contentEditableElement.focus();
          }
        }, 0);
      }
    }

    setInterpretiveQuestions(updatedQuestions);
  };

  const handleInterpretiveAnswersEdit = (index, pIndex = 0) => {
    const updatedQuestions = [...interpretiveQuestions];
    if (isGPT) {
      if (updatedQuestions[index]) {
        updatedQuestions[index].editingAnswer =
          !updatedQuestions[index].editingAnswer;
        setInterpretiveQuestions(updatedQuestions);
      }
    } else {
      if (updatedQuestions[index]) {
        updatedQuestions[index].editingAnswer =
          !updatedQuestions[index].editingAnswer;
        setInterpretiveQuestions(updatedQuestions);
      }
    }
  };

  const handleInterpretiveQuestionDelete = (index, pIndex = 0) => {
    let updatedQuestions = [...interpretiveQuestions];
    if (isGPT) {
      updatedQuestions.splice(index, 1); // Remove the question at the given index
      setInterpretiveCount(totalQuestionNumber - 1);
      setInterpretiveQuestions(updatedQuestions);
    } else {
      updatedQuestions.splice(index, 1); // Remove the question at the given index
      setInterpretiveCount(totalQuestionNumber - 1);
      setInterpretiveQuestions(updatedQuestions);
    }
  };

  useEffect(() => {
    if (generatedQuestionsFromSubmitContent) {
      setInterpretiveQuestions(
        generatedQuestionsFromSubmitContent.response?.questions?.questionset
          ?.interpretive_questions?.questions ||
          generatedQuestionsFromSubmitContent.response?.questions?.questionset
            ?.interpretive_questions ||
          generatedQuestionsFromSubmitContent.questionset
            ?.interpretive_questions?.questions ||
          generatedQuestionsFromSubmitContent.questionset
            ?.interpretive_questions ||
          []
      );
      if (!isGPT) {
        const { questionset = null, response = null } =
          generatedQuestionsFromSubmitContent;
        const questions = questionset
          ? questionset?.interpretive_questions
          : response?.interpretive_questions?.questions || [];
        // If it's an object with a `questions` array inside
        if (Array.isArray(questions.questions)) {
          setInterpretiveCount(questions.questions.length);
        } else if (Array.isArray(questions)) {
          // If it's already an array
          setInterpretiveCount(questions.length);
        } else {
          // Fallback
          setInterpretiveCount(0);
        }
      }
    }
  }, [generatedQuestionsFromSubmitContent]);

  return {
    interpretiveQuestions,
    interpretiveCount,
    handleInterpretiveQuestionChange,
    handleInterpretiveAnswerChange,
    handleInterpretiveQuestionsEdit,
    handleInterpretiveAnswersEdit,
    handleInterpretiveQuestionDelete,
  };
};
